import http from "./http-service";
import { SHARECAREER } from "./endpoint-urls";
import { IShareCareerCount } from "interfaces/ShareCareerCount.interface";

export const updateSharedCareerCount = (data: IShareCareerCount) => {
  return http.put<IShareCareerCount>(`${SHARECAREER}`, data).then((res) => {
    return res.data;
  });
};
